exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inputs {\n    width: 20em;\n}\n\n", ""]);

// exports
